import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  inject,
  input,
  output,
} from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { RippleModule } from 'primeng/ripple';

@Component({
  selector: 'ui-create-button',
  standalone: true,
  imports: [ButtonModule, RippleModule],
  templateUrl: './create-button.component.html',
  styleUrl: './create-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CreateButtonComponent {
  private readonly elementRef = inject(ElementRef);

  public readonly label = input.required<string>();

  public readonly buttonClicked = output<void>();

  protected readonly isTabsButton =
    this.elementRef.nativeElement.classList.contains('tabs__button');
}
